export default "/images/usdt__qr_code.png";